import React from 'react';
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionAnnoucementDetails from "../../../components/sections/front/Annoucements/SectionAnnoucementDetails";

const AnnoucementDetails = () => {
  return (
    <>
      <SectionAnnoucementDetails/>
      <OurPartners />
    </>
  );
};

export default AnnoucementDetails;